var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttentionLarge = function SvgAttentionLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 56C11.536 56-1 43.464-1 28S11.536 0 27 0s28 12.536 28 28-12.536 28-28 28zm0-2c14.36 0 26-11.64 26-26S41.36 2 27 2 1 13.64 1 28s11.64 26 26 26zm-2-32a2 2 0 1 1 4 0v6a2 2 0 1 1-4 0v-6zm2 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
  })));
};
export default SvgAttentionLarge;